import React from 'react';

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <a href="#top" className="logo"><span className="logo-dot" />NIVOCAR</a>
            <p>Infraestrutura completa pra quem quer construir ou expandir uma empresa de rastreamento veicular.</p>
          </div>
          <div className="footer-contact">
            <a href="mailto:contato@nivocar.com.br">contato@nivocar.com.br</a>
            <a href="https://wa.me/5571999083942" target="_blank" rel="noopener noreferrer">(71) 99908-3942</a>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Nivocar. Todos os direitos reservados.</span>
          <span className="mono">nivocar.com.br</span>
        </div>
      </div>
    </footer>
  );
}
